import { SortOption } from './sort-options/types';
import { pushEvent } from '../../../client/data-layer';

// Tracks when the sorting of a product price list changes.
export const trackPriceListSortUpdate = (sort: SortOption) => {
  pushEvent('priceListSortUpdate', { sort });
};

// Tracks when the filter of a product price list changes.
export const trackPriceListFilterUpdate = (
  selectedFilter: string,
  isQuickFilter: boolean
) => {
  pushEvent('priceListFilterUpdate', { selectedFilter, isQuickFilter });
};
